// components/routes/OatiRoute.tsx (Refactored)
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import useSession from '@hooks/useSession';
import styles from './RouteGuard.module.css';

interface OatiRouteProps {
    readonly children: ReactNode;
}

function OatiRoute({ children }: Readonly<OatiRouteProps>) {
    const { isLoggedIn, isOattRateOwner, isOattBillPreparer, isOattBillApprover, loading } = useSession();
    const hasOattAccess = isOattRateOwner || isOattBillPreparer || isOattBillApprover;

    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <Spin size="large" tip="Verifying access...">
                    <div style={{ minHeight: 200 }} />
                </Spin>
            </div>
        );
    }

    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    if (!hasOattAccess) {
        return <Navigate to="/unauthorized" replace />;
    }

    return <>{children}</>;
}

export default OatiRoute;